/* eslint-disable */
// This file is auto-generated by @hey-api/openapi-ts
// Build from env v64.0.6-rc.0
// File ./data/openapi.yaml
// Build 34223116943
// Artifact https://api.github.com/repos/Konova-AG/emi-api/actions/artifacts/10054703741/zip
// Built at 2026-09-22T09:19:11.348Z

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiV1CommentsIdData, DeleteApiV1CommentsIdResponses, DeleteApiV1EvaluationGroupReactionFieldsIdData, DeleteApiV1EvaluationGroupReactionFieldsIdResponses, DeleteApiV1EvaluationPageSettingsIdData, DeleteApiV1EvaluationPageSettingsIdResponses, DeleteApiV1FeedbackTagsIdData, DeleteApiV1FeedbackTagsIdResponses, DeleteApiV1IdeaBoardEntriesBulkDestroyData, DeleteApiV1IdeaBoardEntriesIdData, DeleteApiV1IdeaBoardEntriesIdErrors, DeleteApiV1IdeaBoardEntriesIdResponses, DeleteApiV1ParticipantGroupsParticipantGroupIdData, DeleteApiV1ParticipantGroupsParticipantGroupIdResponses, DeleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserIdData, DeleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserIdResponses, DeleteApiV1ParticipantGroupTagsIdData, DeleteApiV1ParticipantGroupTagsIdResponses, DeleteApiV1ParticipantImportFilesIdData, DeleteApiV1ParticipantImportFilesIdResponses, DeleteApiV1SingleSignOnsIdData, DeleteApiV1SingleSignOnsIdResponses, DeleteApiV1SpaceAssetsIdData, DeleteApiV1SpaceAssetsIdResponses, DeleteApiV1SpaceEmailTemplatesIdData, DeleteApiV1SpacesSpaceIdAdminsSpaceUserIdData, DeleteApiV1SpacesSpaceIdAdminsSpaceUserIdResponses, DeleteApiV1SpacesSpaceIdFaviconData, DeleteApiV1SpacesSpaceIdFaviconResponses, DeleteApiV1SpacesSpaceIdTermsOfUsePdfData, DeleteApiV1SpacesSpaceIdTermsOfUsePdfResponses, DeleteApiV1SpacesSpaceIdUsersUserIdData, DeleteApiV1SpacesSpaceIdUsersUserIdResponses, DeleteApiV1SpaceUsersSpaceUserIdData, DeleteApiV1SurveyCategoriesIdData, DeleteApiV1SurveyCategoriesIdResponses, DeleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentIdData, DeleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentIdResponses, DeleteApiV1SurveyDocumentContentsBulkData, DeleteApiV1SurveyDocumentContentsBulkResponses, DeleteApiV1SurveyDocumentContentsCmsIdData, DeleteApiV1SurveyDocumentContentsCmsIdResponses, DeleteApiV1SurveyDocumentContentsIdData, DeleteApiV1SurveyDocumentContentsIdResponses, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionIdData, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionIdResponses, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupData, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupResponses, DeleteApiV1SurveyDocumentFeedbackGroupsIdData, DeleteApiV1SurveyDocumentFeedbackGroupsIdResponses, DeleteApiV1SurveyDocumentFeedbacksIdData, DeleteApiV1SurveyDocumentFeedbacksIdResponses, DeleteApiV1SurveyDocumentGroupsIdData, DeleteApiV1SurveyDocumentGroupsIdResponses, DeleteApiV1SurveyDocumentGroupTagsIdData, DeleteApiV1SurveyDocumentGroupTagsIdResponses, DeleteApiV1SurveyDocumentPageAreasByLanguageData, DeleteApiV1SurveyDocumentPageAreasByLanguageResponses, DeleteApiV1SurveyDocumentPageAreasIdData, DeleteApiV1SurveyDocumentPageAreasIdResponses, DeleteApiV1SurveyDocumentQuestionsIdData, DeleteApiV1SurveyDocumentQuestionsIdResponses, DeleteApiV1SurveyDocumentsIdData, DeleteApiV1SurveyDocumentsIdResponses, DeleteApiV1SurveyDocumentTagsIdData, DeleteApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdData, DeleteApiV1SurveyEmailTemplatesIdData, DeleteApiV1SurveyEmailTemplatesIdResponses, DeleteApiV1SurveyExportsIdData, DeleteApiV1SurveyExportsIdResponses, DeleteApiV1SurveyModuleAnswersIdData, DeleteApiV1SurveyModuleAnswersIdResponses, DeleteApiV1SurveyModuleQuestionsIdData, DeleteApiV1SurveyModuleQuestionsIdResponses, DeleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswersData, DeleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswersResponses, DeleteApiV1SurveysIdData, DeleteApiV1SurveysIdResponses, DeleteApiV1SurveysSurveyIdUsersSpaceUserIdData, DeleteApiV1SurveysSurveyIdUsersSpaceUserIdResponses, DeleteApiV1SurveyStagesIdData, DeleteApiV1SurveyStagesIdErrors, DeleteApiV1SurveyStagesIdResponses, GetApiV1CommentsData, GetApiV1CommentsIdData, GetApiV1CommentsIdResponses, GetApiV1CommentsResponses, GetApiV1EvaluationGroupReactionFieldsData, GetApiV1EvaluationGroupReactionFieldsIdData, GetApiV1EvaluationGroupReactionFieldsIdResponses, GetApiV1EvaluationGroupReactionFieldsResponses, GetApiV1EvaluationPageSettingsData, GetApiV1EvaluationPageSettingsResponses, GetApiV1EventLogsData, GetApiV1EventLogsResponses, GetApiV1FeedbackTagsData, GetApiV1FeedbackTagsIdData, GetApiV1FeedbackTagsIdResponses, GetApiV1FeedbackTagsResponses, GetApiV1HealthCheckData, GetApiV1HealthCheckResponses, GetApiV1IdeaBoardEntriesData, GetApiV1IdeaBoardEntriesExcelData, GetApiV1IdeaBoardEntriesExcelExportUrlData, GetApiV1IdeaBoardEntriesExcelResponses, GetApiV1IdeaBoardEntriesIdData, GetApiV1IdeaBoardEntriesIdResponses, GetApiV1IdeaBoardEntriesResponses, GetApiV1LocalesLangTranslationJsonData, GetApiV1OauthPasswordResetLeftTimeData, GetApiV1OauthPasswordResetLeftTimeErrors, GetApiV1OauthPasswordResetLeftTimeResponses, GetApiV1OauthSpaceUserSpaceUserIdActivateData, GetApiV1OauthUserData, GetApiV1OauthUserResponses, GetApiV1OauthUserUserIdActivateData, GetApiV1ParticipantGroupsData, GetApiV1ParticipantGroupsExportData, GetApiV1ParticipantGroupsExportResponses, GetApiV1ParticipantGroupsExportUrlData, GetApiV1ParticipantGroupsParticipantGroupIdData, GetApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdfData, GetApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdfResponses, GetApiV1ParticipantGroupsParticipantGroupIdUsersData, GetApiV1ParticipantGroupsParticipantGroupIdUsersResponses, GetApiV1ParticipantGroupsResponses, GetApiV1ParticipantGroupTagsData, GetApiV1ParticipantGroupTagsIdData, GetApiV1ParticipantGroupTagsIdResponses, GetApiV1ParticipantGroupTagsResponses, GetApiV1ParticipantImportFilesData, GetApiV1ParticipantImportFilesIdData, GetApiV1ParticipantImportFilesIdResponses, GetApiV1ParticipantImportFilesResponses, GetApiV1ParticipantsGetCountOnStageData, GetApiV1ParticipantsGetCountOnStageResponses, GetApiV1ParticipantsImportTemplateData, GetApiV1ParticipantsImportTemplateResponses, GetApiV1PlatformFeedbacksData, GetApiV1PlatformFeedbacksIdData, GetApiV1PlatformFeedbacksIdResponses, GetApiV1PlatformFeedbacksResponses, GetApiV1SingleSignOnsData, GetApiV1SingleSignOnsResponses, GetApiV1SpaceAssetsData, GetApiV1SpaceAssetsIdData, GetApiV1SpaceAssetsIdResponses, GetApiV1SpaceAssetsResponses, GetApiV1SpaceAssetsSpaceAssetIdDownloadFilenameData, GetApiV1SpaceAssetsSpaceAssetIdDownloadFilenameResponses, GetApiV1SpaceEmailTemplatesData, GetApiV1SpaceEmailTemplatesIdData, GetApiV1SpacesData, GetApiV1SpacesIdData, GetApiV1SpacesIdResponses, GetApiV1SpacesResponses, GetApiV1SpacesSpaceIdLogoData, GetApiV1SpaceUsersData, GetApiV1SpaceUsersResponses, GetApiV1SsoAzureCallbackData, GetApiV1SsoAzureRedirectUrlData, GetApiV1SsoAzureRedirectUrlResponses, GetApiV1SsoBsCallbackData, GetApiV1SsoBsRedirectUrlData, GetApiV1SsoBsRedirectUrlResponses, GetApiV1SsoEZugCallbackData, GetApiV1SsoEZugRedirectUrlData, GetApiV1SsoEZugRedirectUrlResponses, GetApiV1StorageFilesPathData, GetApiV1SubmissionsData, GetApiV1SubmissionsPublicData, GetApiV1SubmissionsPublicResponses, GetApiV1SubmissionsResponses, GetApiV1SupportZohoOauthData, GetApiV1SurveyCategoriesData, GetApiV1SurveyCategoriesIdData, GetApiV1SurveyCategoriesIdResponses, GetApiV1SurveyCategoriesResponses, GetApiV1SurveyDocumentContentsCmsData, GetApiV1SurveyDocumentContentsCmsIdData, GetApiV1SurveyDocumentContentsCmsIdResponses, GetApiV1SurveyDocumentContentsCmsResponses, GetApiV1SurveyDocumentContentsCmsSurveyDocumentContentCmsDataIdDownloadData, GetApiV1SurveyDocumentContentsData, GetApiV1SurveyDocumentContentsErrors, GetApiV1SurveyDocumentContentsIdData, GetApiV1SurveyDocumentContentsIdResponses, GetApiV1SurveyDocumentContentsImportTemplateData, GetApiV1SurveyDocumentContentsImportTemplateResponses, GetApiV1SurveyDocumentContentsResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupReactionsData, GetApiV1SurveyDocumentFeedbackEvaluationGroupReactionsResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsData, GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelData, GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelExportUrlData, GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupData, GetApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordExportUrlData, GetApiV1SurveyDocumentFeedbackGroupsData, GetApiV1SurveyDocumentFeedbackGroupsErrors, GetApiV1SurveyDocumentFeedbackGroupsIdData, GetApiV1SurveyDocumentFeedbackGroupsResponses, GetApiV1SurveyDocumentFeedbacksData, GetApiV1SurveyDocumentFeedbacksResponses, GetApiV1SurveyDocumentGroupsData, GetApiV1SurveyDocumentGroupsIdData, GetApiV1SurveyDocumentGroupsIdErrors, GetApiV1SurveyDocumentGroupsIdResponses, GetApiV1SurveyDocumentGroupsResponses, GetApiV1SurveyDocumentGroupTagsData, GetApiV1SurveyDocumentGroupTagsIdData, GetApiV1SurveyDocumentGroupTagsIdResponses, GetApiV1SurveyDocumentGroupTagsResponses, GetApiV1SurveyDocumentPageAreasData, GetApiV1SurveyDocumentPageAreasErrors, GetApiV1SurveyDocumentPageAreasResponses, GetApiV1SurveyDocumentQuestionsData, GetApiV1SurveyDocumentQuestionsErrors, GetApiV1SurveyDocumentQuestionsIdData, GetApiV1SurveyDocumentQuestionsIdResponses, GetApiV1SurveyDocumentQuestionsResponses, GetApiV1SurveyDocumentsData, GetApiV1SurveyDocumentsIdData, GetApiV1SurveyDocumentsIdErrors, GetApiV1SurveyDocumentsIdResponses, GetApiV1SurveyDocumentsResponses, GetApiV1SurveyDocumentsSurveyDocumentIdPdfData, GetApiV1SurveyDocumentsSurveyDocumentIdPdfResponses, GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelData, GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelExportUrlData, GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelResponses, GetApiV1SurveyDocumentTagsData, GetApiV1SurveyDocumentTagsIdData, GetApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdDownloadData, GetApiV1SurveyEmailTemplatesData, GetApiV1SurveyEmailTemplatesMailPreviewBodyData, GetApiV1SurveyEmailTemplatesMailPreviewData, GetApiV1SurveyEmailTemplatesMailPreviewResponses, GetApiV1SurveyEmailTemplatesResponses, GetApiV1SurveyEmailTemplatesSurveyEmailTemplateIdData, GetApiV1SurveyEmailTemplatesSurveyEmailTemplateIdResponses, GetApiV1SurveyExportsData, GetApiV1SurveyExportsIdData, GetApiV1SurveyExportsIdResponses, GetApiV1SurveyExportsResponses, GetApiV1SurveyExportsSurveyExportIdDownloadUrlData, GetApiV1SurveyExportsSurveyExportIdDownloadUrlResponses, GetApiV1SurveyModuleAnswersData, GetApiV1SurveyModuleAnswersExcelData, GetApiV1SurveyModuleAnswersExcelExportUrlData, GetApiV1SurveyModuleAnswersExcelResponses, GetApiV1SurveyModuleAnswersResponses, GetApiV1SurveyModuleQuestionsData, GetApiV1SurveyModuleQuestionsResponses, GetApiV1SurveysData, GetApiV1SurveysGeneralReportDownloadData, GetApiV1SurveysResponses, GetApiV1SurveysSurveyBySlugData, GetApiV1SurveysSurveyBySlugLogoData, GetApiV1SurveysSurveyBySlugLogoResponses, GetApiV1SurveysSurveyBySlugResponses, GetApiV1SurveysSurveyIdKeyFiguresData, GetApiV1SurveysSurveyIdKeyFiguresResponses, GetApiV1SurveysSurveyIdStatsData, GetApiV1SurveysSurveyIdTagsData, GetApiV1SurveysSurveyIdTagsResponses, GetApiV1SurveysSurveyIdUsersData, GetApiV1SurveysSurveyIdUsersResponses, GetApiV1SurveyStagesData, GetApiV1SurveyStagesIdData, GetApiV1SurveyStagesIdResponses, GetApiV1SurveyStagesResponses, GetApiV1SurveyStagesSurveyStageIdParticipantGroupsParticipantGroupIdCheckSubmittingRightsData, GetApiV1SurveyStagesSurveyStageIdParticipantGroupsParticipantGroupIdCheckSubmittingRightsResponses, GetApiV1SurveyTagsData, GetApiV1SurveyTagsResponses, GetEmi5857aReactionImageAttachmentMustRenderAsInlineDrawingMlBelowTheTextNeverAsAFloatingVmlwPictShapeThatOverlapsTheTextInWordOnlineGoogleDocsLibreOfficeData, GetEmi5857aReactionImageAttachmentMustRenderAsInlineDrawingMlBelowTheTextNeverAsAFloatingVmlwPictShapeThatOverlapsTheTextInWordOnlineGoogleDocsLibreOfficeResponses, PostApiV1CommentsCommentIdApproveData, PostApiV1CommentsCommentIdUnapproveData, PostApiV1CommentsCommentIdVoteData, PostApiV1CommentsCommentIdVoteResponses, PostApiV1CommentsParentCommentIdCommentData, PostApiV1CommentsParentCommentIdCommentResponses, PostApiV1CreateAnonymousParticipantData, PostApiV1CreateAnonymousParticipantErrors, PostApiV1CreateAnonymousParticipantResponses, PostApiV1EvaluationGroupReactionFieldsData, PostApiV1EvaluationGroupReactionFieldsResponses, PostApiV1EvaluationPageSettingsData, PostApiV1EvaluationPageSettingsResponses, PostApiV1FeedbackTagsData, PostApiV1FeedbackTagsResponses, PostApiV1IdeaBoardEntriesBulkApproveData, PostApiV1IdeaBoardEntriesBulkTagData, PostApiV1IdeaBoardEntriesData, PostApiV1IdeaBoardEntriesErrors, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdApproveData, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentData, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentErrors, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentResponses, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdUnapproveData, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteData, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteErrors, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteResponses, PostApiV1IdeaBoardEntriesResponses, PostApiV1LocalesFlushData, PostApiV1MessagingSendMessageData, PostApiV1MessagingSendMessageResponses, PostApiV1MessagingSendTestMessageData, PostApiV1MessagingSendTestMessageResponses, PostApiV1OauthLogoutData, PostApiV1OauthLogoutResponses, PostApiV1OauthOnboardingTokenData, PostApiV1OauthPasswordEmailData, PostApiV1OauthPasswordSetData, PostApiV1OauthPasswordSetResponses, PostApiV1OauthSecondFactorLoginData, PostApiV1OauthSecondFactorLoginResponses, PostApiV1OauthSendTwoFaTokenData, PostApiV1OauthSendTwoFaTokenResponses, PostApiV1OauthTokenData, PostApiV1OauthTokenErrors, PostApiV1OauthTokenResponses, PostApiV1OauthTokenSsoLoginData, PostApiV1OauthTokenSsoLoginResponses, PostApiV1ParticipantGroupsData, PostApiV1ParticipantGroupsDeleteData, PostApiV1ParticipantGroupsDeleteResponses, PostApiV1ParticipantGroupsResponses, PostApiV1ParticipantGroupTagsData, PostApiV1ParticipantGroupTagsResponses, PostApiV1ParticipantImportFilesData, PostApiV1ParticipantImportFilesResponses, PostApiV1ParticipantsCheckCsvData, PostApiV1ParticipantsCheckCsvErrors, PostApiV1ParticipantsCheckCsvResponses, PostApiV1ParticipantsCsvData, PostApiV1ParticipantsCsvResponses, PostApiV1ParticipantsData, PostApiV1ParticipantsGetOrCreateParticipantGroupForAdminData, PostApiV1ParticipantsGetOrCreateParticipantGroupForAdminResponses, PostApiV1ParticipantsImportFromTemplateData, PostApiV1ParticipantsRegisterData, PostApiV1ParticipantsRegisterErrors, PostApiV1ParticipantsRegisterResponses, PostApiV1ParticipantsResponses, PostApiV1ParticipantsValidateFirstLogonPublicStageFirstStepData, PostApiV1ParticipantsValidateRegistrationFirstStepData, PostApiV1ParticipantsValidateRegistrationFirstStepErrors, PostApiV1ParticipantsValidateRegistrationFirstStepResponses, PostApiV1PlatformFeedbacksData, PostApiV1PlatformFeedbacksResponses, PostApiV1SpaceAssetsData, PostApiV1SpaceAssetsResponses, PostApiV1SpaceEmailTemplatesData, PostApiV1SpacesData, PostApiV1SpacesResponses, PostApiV1SpacesSpaceIdAdminsData, PostApiV1SpacesSpaceIdAdminsResponses, PostApiV1SpaceUsersSpaceUserIdUnlockData, PostApiV1SpaceUsersSpaceUserIdUnlockResponses, PostApiV1SpaceUsersUnionConflictedSpaceUsersAndLoginData, PostApiV1SpaceUsersUnionConflictedSpaceUsersAndLoginResponses, PostApiV1SupportRequestsData, PostApiV1SupportRequestsResponses, PostApiV1SurveyCategoriesData, PostApiV1SurveyCategoriesResponses, PostApiV1SurveyDocumentContentsCmsData, PostApiV1SurveyDocumentContentsCmsResponses, PostApiV1SurveyDocumentContentsData, PostApiV1SurveyDocumentContentsImportData, PostApiV1SurveyDocumentContentsImportErrors, PostApiV1SurveyDocumentContentsImportResponses, PostApiV1SurveyDocumentContentsResponses, PostApiV1SurveyDocumentFeedbackEvaluationGroupReactionsData, PostApiV1SurveyDocumentFeedbackEvaluationGroupReactionsResponses, PostApiV1SurveyDocumentFeedbackEvaluationGroupsData, PostApiV1SurveyDocumentFeedbackEvaluationGroupsImportData, PostApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, PostApiV1SurveyDocumentFeedbackGroupsData, PostApiV1SurveyDocumentFeedbackGroupsErrors, PostApiV1SurveyDocumentFeedbackGroupsResponses, PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackData, PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackErrors, PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackResponses, PostApiV1SurveyDocumentFeedbacksData, PostApiV1SurveyDocumentFeedbacksResponses, PostApiV1SurveyDocumentGroupsData, PostApiV1SurveyDocumentGroupsResponses, PostApiV1SurveyDocumentGroupTagsData, PostApiV1SurveyDocumentGroupTagsResponses, PostApiV1SurveyDocumentPageAreasCopyLanguageData, PostApiV1SurveyDocumentPageAreasCopyLanguageErrors, PostApiV1SurveyDocumentPageAreasCopyLanguageResponses, PostApiV1SurveyDocumentPageAreasData, PostApiV1SurveyDocumentPageAreasResponses, PostApiV1SurveyDocumentPageAreasStoreMassData, PostApiV1SurveyDocumentPageAreasStoreMassResponses, PostApiV1SurveyDocumentQuestionAnswersMassData, PostApiV1SurveyDocumentQuestionAnswersMassResponses, PostApiV1SurveyDocumentQuestionsData, PostApiV1SurveyDocumentQuestionsMassData, PostApiV1SurveyDocumentQuestionsMassResponses, PostApiV1SurveyDocumentQuestionsResponses, PostApiV1SurveyDocumentsData, PostApiV1SurveyDocumentsResponses, PostApiV1SurveyDocumentTagsData, PostApiV1SurveyEmailTemplatesData, PostApiV1SurveyEmailTemplatesResponses, PostApiV1SurveyEmailTemplatesSendTestData, PostApiV1SurveyEmailTemplatesSendTestResponses, PostApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSendData, PostApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSendResponses, PostApiV1SurveyExportsData, PostApiV1SurveyExportsResponses, PostApiV1SurveyModuleAnswersData, PostApiV1SurveyModuleAnswersResponses, PostApiV1SurveyModuleQuestionsData, PostApiV1SurveyModuleQuestionsResponses, PostApiV1SurveysData, PostApiV1SurveysErrors, PostApiV1SurveysResponses, PostApiV1SurveysSurveyIdCopyData, PostApiV1SurveysSurveyIdCopyResponses, PostApiV1SurveysSurveyIdDispatchSearchForSimilarEvaluationGroupsData, PostApiV1SurveysSurveyIdPublishSubmissionData, PostApiV1SurveysSurveyIdPublishSubmissionResponses, PostApiV1SurveysSurveyIdRevokeSubmitData, PostApiV1SurveysSurveyIdRevokeSubmitErrors, PostApiV1SurveysSurveyIdRevokeSubmitResponses, PostApiV1SurveysSurveyIdSendInvitationEmailData, PostApiV1SurveysSurveyIdSendInvitationEmailResponses, PostApiV1SurveysSurveyIdSendParticipantReactionReportData, PostApiV1SurveysSurveyIdSendRecordingReminderData, PostApiV1SurveysSurveyIdSendRecordingReminderResponses, PostApiV1SurveysSurveyIdSendSubmittingReminderData, PostApiV1SurveysSurveyIdSendSubmittingReminderResponses, PostApiV1SurveysSurveyIdSubmitData, PostApiV1SurveysSurveyIdSubmitResponses, PostApiV1SurveyStagesData, PostApiV1SurveyStagesResponses, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsAttachData, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsAttachResponses, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsDetachData, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsDetachResponses, PostApiV1TranslationsFlushData, PostChangeTeamAdminOfAParticipantGroupData, PostChangeTeamAdminOfAParticipantGroupErrors, PostChangeTeamAdminOfAParticipantGroupResponses, PostEmi5799RelatedPathASpaceUserForTheGivenEmailSpaceExistsButWasPreviouslySoftDeletedTheEndpointMustRestoreTheExistingSpaceUserAndAttachItToTheGroupNotCreateADuplicateRowData, PostEmi5799RelatedPathASpaceUserForTheGivenEmailSpaceExistsButWasPreviouslySoftDeletedTheEndpointMustRestoreTheExistingSpaceUserAndAttachItToTheGroupNotCreateADuplicateRowResponses, PostReproducesEmi5799aUserWithTheInvitedEmailExistsButWasPreviouslySoftDeletedAndNoSpaceUserExistsForThatEmailInTheSurveySSpaceData, PostReproducesEmi5799aUserWithTheInvitedEmailExistsButWasPreviouslySoftDeletedAndNoSpaceUserExistsForThatEmailInTheSurveySSpaceResponses, PutApiV1CommentsIdData, PutApiV1CommentsIdErrors, PutApiV1CommentsIdResponses, PutApiV1EvaluationGroupReactionFieldsIdData, PutApiV1EvaluationGroupReactionFieldsIdResponses, PutApiV1EvaluationGroupReactionFieldsSortData, PutApiV1EvaluationGroupReactionFieldsSortResponses, PutApiV1EvaluationPageSettingsIdData, PutApiV1EvaluationPageSettingsIdResponses, PutApiV1FeedbackTagsIdData, PutApiV1FeedbackTagsIdResponses, PutApiV1IdeaBoardEntriesIdData, PutApiV1IdeaBoardEntriesIdResponses, PutApiV1OauthSendEmailVerificationLinkData, PutApiV1OauthSendEmailVerificationLinkResponses, PutApiV1OauthSetup2FaData, PutApiV1OauthSetup2FaResponses, PutApiV1OauthUserUserIdVerifyEmailData, PutApiV1OauthUserUserIdVerifyEmailErrors, PutApiV1OauthUserUserIdVerifyEmailResponses, PutApiV1OauthVerifyPhoneData, PutApiV1OauthVerifyPhoneErrors, PutApiV1OauthVerifyPhoneResponses, PutApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdfData, PutApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdfResponses, PutApiV1ParticipantGroupsParticipantGroupIdData, PutApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdfData, PutApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdfResponses, PutApiV1ParticipantGroupsParticipantGroupIdErrors, PutApiV1ParticipantGroupsParticipantGroupIdResponses, PutApiV1ParticipantGroupsParticipantGroupIdSyncToStageData, PutApiV1ParticipantGroupsParticipantGroupIdSyncToStageResponses, PutApiV1ParticipantGroupsSyncTagsData, PutApiV1ParticipantGroupsSyncTagsResponses, PutApiV1ParticipantGroupTagsIdData, PutApiV1ParticipantGroupTagsIdResponses, PutApiV1ParticipantImportFilesIdData, PutApiV1ParticipantImportFilesIdResponses, PutApiV1ParticipantsImportFromStageData, PutApiV1ParticipantsImportFromStageResponses, PutApiV1PlatformFeedbacksIdData, PutApiV1PlatformFeedbacksIdResponses, PutApiV1SpaceAssetsIdData, PutApiV1SpaceAssetsIdResponses, PutApiV1SpaceEmailTemplatesIdData, PutApiV1SpacesIdData, PutApiV1SpacesIdResponses, PutApiV1SubmissionsIdData, PutApiV1SubmissionsIdResponses, PutApiV1SurveyCategoriesIdData, PutApiV1SurveyCategoriesIdResponses, PutApiV1SurveyCategoriesSortData, PutApiV1SurveyCategoriesSortResponses, PutApiV1SurveyDocumentContentsBulkData, PutApiV1SurveyDocumentContentsBulkResponses, PutApiV1SurveyDocumentContentsCmsIdData, PutApiV1SurveyDocumentContentsCmsIdResponses, PutApiV1SurveyDocumentContentsIdData, PutApiV1SurveyDocumentContentsIdResponses, PutApiV1SurveyDocumentContentsSortData, PutApiV1SurveyDocumentContentsSortResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSortData, PutApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSortResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestionsData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestionsResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroupsData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroupsResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMergeData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMergeResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsHideData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsHideResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsShowData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsShowResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsTagsData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsTagsResponses, PutApiV1SurveyDocumentFeedbackGroupsAffiliateData, PutApiV1SurveyDocumentFeedbackGroupsAffiliateResponses, PutApiV1SurveyDocumentFeedbackGroupsDisaffiliateData, PutApiV1SurveyDocumentFeedbackGroupsDisaffiliateResponses, PutApiV1SurveyDocumentFeedbackGroupsIdData, PutApiV1SurveyDocumentFeedbackGroupsIdErrors, PutApiV1SurveyDocumentFeedbackGroupsIdResponses, PutApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplitData, PutApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplitResponses, PutApiV1SurveyDocumentGroupsIdData, PutApiV1SurveyDocumentGroupsIdResponses, PutApiV1SurveyDocumentGroupsSortData, PutApiV1SurveyDocumentGroupsSortResponses, PutApiV1SurveyDocumentGroupTagsIdData, PutApiV1SurveyDocumentGroupTagsIdResponses, PutApiV1SurveyDocumentPageAreasIdData, PutApiV1SurveyDocumentPageAreasIdResponses, PutApiV1SurveyDocumentQuestionsIdData, PutApiV1SurveyDocumentQuestionsIdResponses, PutApiV1SurveyDocumentsIdData, PutApiV1SurveyDocumentsIdResponses, PutApiV1SurveyDocumentsSortData, PutApiV1SurveyDocumentsSortResponses, PutApiV1SurveyDocumentTagsIdData, PutApiV1SurveyEmailTemplatesIdData, PutApiV1SurveyEmailTemplatesIdResponses, PutApiV1SurveyModuleAnswersIdData, PutApiV1SurveyModuleAnswersIdResponses, PutApiV1SurveyModuleQuestionsIdData, PutApiV1SurveyModuleQuestionsIdResponses, PutApiV1SurveysSortData, PutApiV1SurveysSortResponses, PutApiV1SurveysSurveyIdArchiveData, PutApiV1SurveysSurveyIdArchiveResponses, PutApiV1SurveysSurveyIdRemoveParticipantGroupsData, PutApiV1SurveysSurveyIdRemoveParticipantGroupsResponses, PutApiV1SurveysSurveyIdUnarchiveData, PutApiV1SurveysSurveyIdUnarchiveResponses, PutApiV1SurveyStagesIdData, PutApiV1SurveyStagesIdResponses, PutApiV1UsersUserIdData, PutApiV1UsersUserIdResponses, PutApiV1UsersUserIdVerifyEmailData, PutApiV1UsersUserIdVerifyEmailResponses, PutChangingAParticipantGroupSStageStateViaUpdateStateMustWriteALogEntryLogEventCapturingTheOldAndNewStateData, PutChangingAParticipantGroupSStageStateViaUpdateStateMustWriteALogEntryLogEventCapturingTheOldAndNewStateResponses, PutEmi5799RelatedPathAuserChangesTheirOwnEmailToOneThatBelongsToAPreviouslySoftDeletedUserAccountTheCurrentBehaviourCrashesWithUniqueConstraintViolationExceptionBecauseTheConflictLookupInConflictedUsersResolveServiceDoesNotConsiderTrashedRowsTheEmailUpdateAtTheEndOfTheFlowThenCollidesWithTheUniqueIndexOnUsersEmailData, PutEmi5799RelatedPathAuserChangesTheirOwnEmailToOneThatBelongsToAPreviouslySoftDeletedUserAccountTheCurrentBehaviourCrashesWithUniqueConstraintViolationExceptionBecauseTheConflictLookupInConflictedUsersResolveServiceDoesNotConsiderTrashedRowsTheEmailUpdateAtTheEndOfTheFlowThenCollidesWithTheUniqueIndexOnUsersEmailResponses, PutUpdateASurveyData, PutUpdateASurveyResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const postApiV1OauthToken = <ThrowOnError extends boolean = false>(options: Options<PostApiV1OauthTokenData, ThrowOnError>) => (options.client ?? client).post<PostApiV1OauthTokenResponses, PostApiV1OauthTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/oauth/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1OauthTokenSsoLogin = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1OauthTokenSsoLoginData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1OauthTokenSsoLoginResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/token/sso-login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiV1OauthLogout = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1OauthLogoutData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1OauthLogoutResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/oauth/logout',
    ...options
});

/**
 * /api/v1/oauth/password/email
 *
 * Send password reset link.
 */
export const postApiV1OauthPasswordEmail = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1OauthPasswordEmailData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/password/email',
    ...options
});

/**
 * /api/v1/oauth/password/set
 *
 * Reset password.
 */
export const postApiV1OauthPasswordSet = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1OauthPasswordSetData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1OauthPasswordSetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/password/set',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiV1OauthPasswordResetLeftTime = <ThrowOnError extends boolean = false>(options: Options<GetApiV1OauthPasswordResetLeftTimeData, ThrowOnError>) => (options.client ?? client).get<GetApiV1OauthPasswordResetLeftTimeResponses, GetApiV1OauthPasswordResetLeftTimeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/password/reset-left-time',
    ...options
});

export const postApiV1OauthOnboardingToken = <ThrowOnError extends boolean = false>(options: Options<PostApiV1OauthOnboardingTokenData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    url: '/api/v1/oauth/onboarding-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1OauthSendEmailVerificationLink = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1OauthSendEmailVerificationLinkData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1OauthSendEmailVerificationLinkResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/send-email-verification-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiV1SsoAzureRedirectUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoAzureRedirectUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SsoAzureRedirectUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/sso/azure/redirect-url',
    ...options
});

export const getApiV1SsoAzureCallback = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoAzureCallbackData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/api/v1/sso/azure/callback', ...options });

export const getApiV1SsoEZugRedirectUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoEZugRedirectUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SsoEZugRedirectUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/sso/e-zug/redirect-url',
    ...options
});

export const getApiV1SsoEZugCallback = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoEZugCallbackData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/api/v1/sso/e-zug/callback', ...options });

export const getApiV1SsoBsRedirectUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoBsRedirectUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SsoBsRedirectUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/sso/bs/redirect-url',
    ...options
});

export const getApiV1SsoBsCallback = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoBsCallbackData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/api/v1/sso/bs/callback', ...options });

export const putApiV1OauthVerifyPhone = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1OauthVerifyPhoneData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1OauthVerifyPhoneResponses, PutApiV1OauthVerifyPhoneErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/verify-phone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiV1OauthSecondFactorLogin = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1OauthSecondFactorLoginData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1OauthSecondFactorLoginResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/second-factor-login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiV1OauthSetup2Fa = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1OauthSetup2FaData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1OauthSetup2FaResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/setup-2fa',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiV1OauthSendTwoFaToken = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1OauthSendTwoFaTokenData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1OauthSendTwoFaTokenResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/send-two-fa-token',
    ...options
});

/**
 * **Response:** [SingleSignOnResource](#model/SingleSignOnResource)[]
 */
export const getApiV1SingleSignOns = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SingleSignOnsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SingleSignOnsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/single-sign-ons',
    ...options
});

export const deleteApiV1SingleSignOnsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SingleSignOnsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SingleSignOnsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/single-sign-ons/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/oauth/space-user/{spaceUser_id}/activate
 *
 * Activate space user by invitation link.
 */
export const getApiV1OauthSpaceUserSpaceUserIdActivate = <ThrowOnError extends boolean = false>(options: Options<GetApiV1OauthSpaceUserSpaceUserIdActivateData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/api/v1/oauth/space-user/{spaceUser_id}/activate', ...options });

/**
 * /api/v1/oauth/user/{user_id}/activate
 *
 * Activate user by token.
 */
export const getApiV1OauthUserUserIdActivate = <ThrowOnError extends boolean = false>(options: Options<GetApiV1OauthUserUserIdActivateData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/api/v1/oauth/user/{user_id}/activate', ...options });

export const putApiV1OauthUserUserIdVerifyEmail = <ThrowOnError extends boolean = false>(options: Options<PutApiV1OauthUserUserIdVerifyEmailData, ThrowOnError>) => (options.client ?? client).put<PutApiV1OauthUserUserIdVerifyEmailResponses, PutApiV1OauthUserUserIdVerifyEmailErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/user/{user_id}/verify-email',
    ...options
});

export const postApiV1ParticipantsValidateRegistrationFirstStep = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1ParticipantsValidateRegistrationFirstStepData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1ParticipantsValidateRegistrationFirstStepResponses, PostApiV1ParticipantsValidateRegistrationFirstStepErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/participants/validate-registration-first-step',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiV1ParticipantsValidateFirstLogonPublicStageFirstStep = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsValidateFirstLogonPublicStageFirstStepData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    url: '/api/v1/participants/validate-first-logon-public-stage-first-step',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/participants/register
 *
 * Register a participant.
 */
export const postApiV1ParticipantsRegister = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1ParticipantsRegisterData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1ParticipantsRegisterResponses, PostApiV1ParticipantsRegisterErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/participants/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiV1SurveyDocumentContentsImportTemplate = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentContentsImportTemplateData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentContentsImportTemplateResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/import-template',
    ...options
});

export const postApiV1SurveyDocumentContentsImport = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentContentsImportData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentContentsImportResponses, PostApiV1SurveyDocumentContentsImportErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentContentsSort = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyDocumentContentsSortData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyDocumentContentsSortResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1SurveyDocumentContentsBulk = <ThrowOnError extends boolean = false>(options?: Options<DeleteApiV1SurveyDocumentContentsBulkData, ThrowOnError>) => (options?.client ?? client).delete<DeleteApiV1SurveyDocumentContentsBulkResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [SurveyDocumentContentResource](#model/SurveyDocumentContentResource)[]
 */
export const putApiV1SurveyDocumentContentsBulk = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyDocumentContentsBulkData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyDocumentContentsBulkResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-document-contents
 *
 * List content blocks.
 *
 * **Response:** [SurveyDocumentContentResource](#model/SurveyDocumentContentResource)[]
 */
export const getApiV1SurveyDocumentContents = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentContentsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentContentsResponses, GetApiV1SurveyDocumentContentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents',
    ...options
});

/**
 * /api/v1/survey-document-contents
 *
 * Create a content block.
 *
 * **Response:** [SurveyDocumentContentResource](#model/SurveyDocumentContentResource)
 */
export const postApiV1SurveyDocumentContents = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentContentsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentContentsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-document-contents/{id}
 *
 * Delete a content block.
 */
export const deleteApiV1SurveyDocumentContentsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentContentsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentContentsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/{id}',
    ...options
});

/**
 * /api/v1/survey-document-contents/{id}
 *
 * Show a content block.
 *
 * **Response:** [SurveyDocumentContentResource](#model/SurveyDocumentContentResource)
 */
export const getApiV1SurveyDocumentContentsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentContentsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentContentsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/{id}',
    ...options
});

/**
 * /api/v1/survey-document-contents/{id}
 *
 * Update a content block.
 *
 * **Response:** [SurveyDocumentContentResource](#model/SurveyDocumentContentResource)
 */
export const putApiV1SurveyDocumentContentsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentContentsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentContentsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-contents-cms
 *
 * List CMS content blocks.
 *
 * **Response:** [SurveyDocumentContentCmsResource](#model/SurveyDocumentContentCmsResource)[]
 */
export const getApiV1SurveyDocumentContentsCms = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentContentsCmsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentContentsCmsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents-cms',
    ...options
});

/**
 * /api/v1/survey-document-contents-cms
 *
 * Create a CMS content block.
 *
 * **Response:** [SurveyDocumentContentCmsResource](#model/SurveyDocumentContentCmsResource)
 */
export const postApiV1SurveyDocumentContentsCms = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentContentsCmsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentContentsCmsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents-cms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-document-contents-cms/{id}
 *
 * Delete a CMS content block.
 */
export const deleteApiV1SurveyDocumentContentsCmsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentContentsCmsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentContentsCmsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents-cms/{id}',
    ...options
});

/**
 * /api/v1/survey-document-contents-cms/{id}
 *
 * Show a CMS content block.
 *
 * **Response:** [SurveyDocumentContentCmsResource](#model/SurveyDocumentContentCmsResource)
 */
export const getApiV1SurveyDocumentContentsCmsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentContentsCmsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentContentsCmsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents-cms/{id}',
    ...options
});

/**
 * /api/v1/survey-document-contents-cms/{id}
 *
 * Update a CMS content block.
 *
 * **Response:** [SurveyDocumentContentCmsResource](#model/SurveyDocumentContentCmsResource)
 */
export const putApiV1SurveyDocumentContentsCmsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentContentsCmsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentContentsCmsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents-cms/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-content-attachments/{surveyDocumentContentAttachment_id}
 *
 * Delete a content attachment.
 */
export const deleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-content-attachments/{surveyDocumentContentAttachment_id}',
    ...options
});

export const getApiV1SurveyDocumentContentsCmsSurveyDocumentContentCmsDataIdDownload = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentContentsCmsSurveyDocumentContentCmsDataIdDownloadData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents-cms/{surveyDocumentContentCmsData_id}/download',
    ...options
});

/**
 * **Response:** [SurveyDocumentQuestionResource](#model/SurveyDocumentQuestionResource)[]
 */
export const postApiV1SurveyDocumentQuestionsMass = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentQuestionsMassData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentQuestionsMassResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-questions/mass',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [SurveyDocumentQuestionResource](#model/SurveyDocumentQuestionResource)[]
 */
export const getApiV1SurveyDocumentQuestions = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentQuestionsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentQuestionsResponses, GetApiV1SurveyDocumentQuestionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-questions',
    ...options
});

/**
 * /api/v1/survey-document-questions
 *
 * Create a document question.
 *
 * **Response:** [SurveyDocumentQuestionResource](#model/SurveyDocumentQuestionResource)
 */
export const postApiV1SurveyDocumentQuestions = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentQuestionsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentQuestionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-questions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-document-questions/{id}
 *
 * Delete a document question.
 */
export const deleteApiV1SurveyDocumentQuestionsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentQuestionsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentQuestionsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-questions/{id}',
    ...options
});

/**
 * /api/v1/survey-document-questions/{id}
 *
 * Show a document question.
 *
 * **Response:** [SurveyDocumentQuestionResource](#model/SurveyDocumentQuestionResource)
 */
export const getApiV1SurveyDocumentQuestionsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentQuestionsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentQuestionsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-questions/{id}',
    ...options
});

/**
 * /api/v1/survey-document-questions/{id}
 *
 * Update a document question.
 *
 * **Response:** [SurveyDocumentQuestionResource](#model/SurveyDocumentQuestionResource)
 */
export const putApiV1SurveyDocumentQuestionsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentQuestionsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentQuestionsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-questions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveyDocumentQuestionAnswersMass = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentQuestionAnswersMassData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentQuestionAnswersMassResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-question-answers/mass',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiV1SurveyEmailTemplatesSendTest = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyEmailTemplatesSendTestData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyEmailTemplatesSendTestResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/send-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiV1SurveyEmailTemplatesMailPreview = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyEmailTemplatesMailPreviewData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyEmailTemplatesMailPreviewResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/mail-preview',
    ...options
});

/**
 * **Response:** [SurveyEmailTemplateResource](#model/SurveyEmailTemplateResource)[]
 */
export const getApiV1SurveyEmailTemplates = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyEmailTemplatesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyEmailTemplatesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates',
    ...options
});

/**
 * **Response:** [SurveyEmailTemplateResource](#model/SurveyEmailTemplateResource)
 */
export const postApiV1SurveyEmailTemplates = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyEmailTemplatesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyEmailTemplatesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyEmailTemplatesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyEmailTemplatesIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyEmailTemplatesIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/{id}',
    ...options
});

/**
 * **Response:** [SurveyEmailTemplateResource](#model/SurveyEmailTemplateResource)
 */
export const putApiV1SurveyEmailTemplatesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyEmailTemplatesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyEmailTemplatesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [SurveyEmailTemplateResource](#model/SurveyEmailTemplateResource)
 */
export const getApiV1SurveyEmailTemplatesSurveyEmailTemplateId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyEmailTemplatesSurveyEmailTemplateIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyEmailTemplatesSurveyEmailTemplateIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/{surveyEmailTemplate_id}',
    ...options
});

export const deleteApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdData, ThrowOnError>) => (options.client ?? client).delete<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-template-attachment/{surveyEmailTemplateAttachment_id}',
    ...options
});

export const postApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSend = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSendData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSendResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/{surveyEmailTemplate_id}/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyEmailTemplatesMailPreviewBody = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyEmailTemplatesMailPreviewBodyData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/mail-preview-body',
    ...options
});

export const getApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdDownload = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdDownloadData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-template-attachment/{surveyEmailTemplateAttachment_id}/download',
    ...options
});

/**
 * **Response:** [SpaceEmailTemplateResource](#model/SpaceEmailTemplateResource)[]
 */
export const getApiV1SpaceEmailTemplates = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpaceEmailTemplatesData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-email-templates',
    ...options
});

/**
 * **Response:** [SpaceEmailTemplateResource](#model/SpaceEmailTemplateResource)
 */
export const postApiV1SpaceEmailTemplates = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SpaceEmailTemplatesData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-email-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SpaceEmailTemplatesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpaceEmailTemplatesIdData, ThrowOnError>) => (options.client ?? client).delete<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-email-templates/{id}',
    ...options
});

/**
 * **Response:** [SpaceEmailTemplateResource](#model/SpaceEmailTemplateResource)
 */
export const getApiV1SpaceEmailTemplatesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpaceEmailTemplatesIdData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-email-templates/{id}',
    ...options
});

/**
 * **Response:** [SpaceEmailTemplateResource](#model/SpaceEmailTemplateResource)
 */
export const putApiV1SpaceEmailTemplatesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SpaceEmailTemplatesIdData, ThrowOnError>) => (options.client ?? client).put<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-email-templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [UserResource](#model/UserResource)
 */
export const postApiV1CreateAnonymousParticipant = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1CreateAnonymousParticipantData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1CreateAnonymousParticipantResponses, PostApiV1CreateAnonymousParticipantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/create-anonymous-participant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [SurveyDocumentTagResource](#model/SurveyDocumentTagResource)[]
 */
export const getApiV1SurveyDocumentTags = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentTagsData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-tags',
    ...options
});

/**
 * **Response:** [SurveyDocumentTagResource](#model/SurveyDocumentTagResource)
 */
export const postApiV1SurveyDocumentTags = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentTagsData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyDocumentTagsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentTagsIdData, ThrowOnError>) => (options.client ?? client).delete<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-tags/{id}',
    ...options
});

/**
 * **Response:** [SurveyDocumentTagResource](#model/SurveyDocumentTagResource)
 */
export const getApiV1SurveyDocumentTagsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentTagsIdData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-tags/{id}',
    ...options
});

/**
 * **Response:** [SurveyDocumentTagResource](#model/SurveyDocumentTagResource)
 */
export const putApiV1SurveyDocumentTagsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentTagsIdData, ThrowOnError>) => (options.client ?? client).put<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}/merge
 *
 * Merge feedback groups into an evaluation group.
 *
 * **Response:** [SurveyDocumentFeedbackEvaluationGroupResource](#model/SurveyDocumentFeedbackEvaluationGroupResource)
 */
export const putApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMerge = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMergeData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMergeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [SurveyDocumentFeedbackEvaluationGroupResource](#model/SurveyDocumentFeedbackEvaluationGroupResource)
 */
export const putApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroups = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroupsData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroupsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}/detach-survey-document-feedback-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}/decline-suggestions
 *
 * Decline suggested feedback groups.
 *
 * **Response:** [SurveyDocumentFeedbackEvaluationGroupResource](#model/SurveyDocumentFeedbackEvaluationGroupResource)
 */
export const putApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestions = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestionsData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}/decline-suggestions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentFeedbackEvaluationGroupsTags = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsTagsData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsTagsResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiV1SurveyDocumentFeedbackEvaluationGroupsHide = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsHideData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsHideResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/hide',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiV1SurveyDocumentFeedbackEvaluationGroupsShow = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsShowData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsShowResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/show',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiV1SurveyDocumentFeedbackEvaluationGroupsWordExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordExportUrlData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/word-export-url',
    ...options
});

/**
 * /api/v1/survey-document-feedback-evaluation-groups
 *
 * List feedback evaluation groups.
 */
export const getApiV1SurveyDocumentFeedbackEvaluationGroups = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups',
    ...options
});

/**
 * **Response:** [SurveyDocumentFeedbackEvaluationGroupResource](#model/SurveyDocumentFeedbackEvaluationGroupResource)
 */
export const postApiV1SurveyDocumentFeedbackEvaluationGroups = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentFeedbackEvaluationGroupsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [SurveyDocumentFeedbackEvaluationGroupResource](#model/SurveyDocumentFeedbackEvaluationGroupResource)[]
 */
export const putApiV1SurveyDocumentFeedbackEvaluationGroups = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiV1SurveyDocumentFeedbackEvaluationGroupsExcelExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelExportUrlData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/excel-export-url',
    ...options
});

export const postApiV1SurveyDocumentFeedbackEvaluationGroupsImport = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentFeedbackEvaluationGroupsImportData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}',
    ...options
});

/**
 * **Response:** [SurveyDocumentFeedbackEvaluationGroupResource](#model/SurveyDocumentFeedbackEvaluationGroupResource)
 */
export const getApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroup = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}',
    ...options
});

export const putApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSort = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSortData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSortResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-group-reactions/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [SurveyDocumentFeedbackEvaluationGroupReactionResource](#model/SurveyDocumentFeedbackEvaluationGroupReactionResource)[]
 */
export const getApiV1SurveyDocumentFeedbackEvaluationGroupReactions = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupReactionsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackEvaluationGroupReactionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-group-reactions',
    ...options
});

export const postApiV1SurveyDocumentFeedbackEvaluationGroupReactions = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentFeedbackEvaluationGroupReactionsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentFeedbackEvaluationGroupReactionsResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-group-reactions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-group-reactions/{evaluation_group_reaction_id}',
    ...options
});

export const putApiV1EvaluationGroupReactionFieldsSort = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1EvaluationGroupReactionFieldsSortData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1EvaluationGroupReactionFieldsSortResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [EvaluationGroupReactionFieldResource](#model/EvaluationGroupReactionFieldResource)[]
 */
export const getApiV1EvaluationGroupReactionFields = <ThrowOnError extends boolean = false>(options: Options<GetApiV1EvaluationGroupReactionFieldsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1EvaluationGroupReactionFieldsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields',
    ...options
});

/**
 * **Response:** [EvaluationGroupReactionFieldResource](#model/EvaluationGroupReactionFieldResource)
 */
export const postApiV1EvaluationGroupReactionFields = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1EvaluationGroupReactionFieldsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1EvaluationGroupReactionFieldsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1EvaluationGroupReactionFieldsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1EvaluationGroupReactionFieldsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1EvaluationGroupReactionFieldsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields/{id}',
    ...options
});

/**
 * **Response:** [EvaluationGroupReactionFieldResource](#model/EvaluationGroupReactionFieldResource)
 */
export const getApiV1EvaluationGroupReactionFieldsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1EvaluationGroupReactionFieldsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1EvaluationGroupReactionFieldsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields/{id}',
    ...options
});

/**
 * **Response:** [EvaluationGroupReactionFieldResource](#model/EvaluationGroupReactionFieldResource)
 */
export const putApiV1EvaluationGroupReactionFieldsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1EvaluationGroupReactionFieldsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1EvaluationGroupReactionFieldsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * EMI-5857: a reaction image attachment must render as inline DrawingML
 * (below the text), never as a floating VML `<w:pict>` shape that overlaps
 * the text in Word Online / Google Docs / LibreOffice.
 */
export const getEmi5857aReactionImageAttachmentMustRenderAsInlineDrawingMlBelowTheTextNeverAsAFloatingVmlwPictShapeThatOverlapsTheTextInWordOnlineGoogleDocsLibreOffice = <ThrowOnError extends boolean = false>(options: Options<GetEmi5857aReactionImageAttachmentMustRenderAsInlineDrawingMlBelowTheTextNeverAsAFloatingVmlwPictShapeThatOverlapsTheTextInWordOnlineGoogleDocsLibreOfficeData, ThrowOnError>) => (options.client ?? client).get<GetEmi5857aReactionImageAttachmentMustRenderAsInlineDrawingMlBelowTheTextNeverAsAFloatingVmlwPictShapeThatOverlapsTheTextInWordOnlineGoogleDocsLibreOfficeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/word',
    ...options
});

export const getApiV1SurveyDocumentFeedbackEvaluationGroupsExcel = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/excel',
    ...options
});

export const putApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplit = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplitData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplitResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/{surveyDocumentFeedbackGroup_id}/split',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentFeedbackGroupsAffiliate = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyDocumentFeedbackGroupsAffiliateData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyDocumentFeedbackGroupsAffiliateResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/affiliate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiV1SurveyDocumentFeedbackGroupsDisaffiliate = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyDocumentFeedbackGroupsDisaffiliateData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyDocumentFeedbackGroupsDisaffiliateResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/disaffiliate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-document-feedback-groups/with-feedback
 *
 * Create a feedback group and its first feedback in a single call. Combines the legacy two-step flow (POST /survey-document-feedback-groups followed by POST /survey-document-feedbacks)
 *
 * **Response:** [SurveyDocumentFeedbackGroupResource](#model/SurveyDocumentFeedbackGroupResource)
 */
export const postApiV1SurveyDocumentFeedbackGroupsWithFeedback = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackResponses, PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/with-feedback',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * **Response:** [SurveyDocumentFeedbackGroupResource](#model/SurveyDocumentFeedbackGroupResource)[]
 */
export const getApiV1SurveyDocumentFeedbackGroups = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackGroupsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackGroupsResponses, GetApiV1SurveyDocumentFeedbackGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups',
    ...options
});

/**
 * /api/v1/survey-document-feedback-groups
 *
 * Create a feedback group.
 *
 * **Response:** [SurveyDocumentFeedbackGroupResource](#model/SurveyDocumentFeedbackGroupResource)
 */
export const postApiV1SurveyDocumentFeedbackGroups = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentFeedbackGroupsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentFeedbackGroupsResponses, PostApiV1SurveyDocumentFeedbackGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1SurveyDocumentFeedbackGroupsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentFeedbackGroupsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentFeedbackGroupsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyDocumentFeedbackGroupsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackGroupsIdData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/{id}',
    ...options
});

/**
 * **Response:** [SurveyDocumentFeedbackGroupResource](#model/SurveyDocumentFeedbackGroupResource)
 */
export const putApiV1SurveyDocumentFeedbackGroupsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackGroupsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackGroupsIdResponses, PutApiV1SurveyDocumentFeedbackGroupsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-feedbacks
 *
 * List feedbacks for a feedback group.
 *
 * **Response:** [SurveyDocumentFeedbackResource](#model/SurveyDocumentFeedbackResource)[]
 */
export const getApiV1SurveyDocumentFeedbacks = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbacksData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbacksResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedbacks',
    ...options
});

/**
 * /api/v1/survey-document-feedbacks
 *
 * Create a new feedback.
 */
export const postApiV1SurveyDocumentFeedbacks = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentFeedbacksData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentFeedbacksResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedbacks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyDocumentFeedbacksId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentFeedbacksIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentFeedbacksIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedbacks/{id}',
    ...options
});

/**
 * **Response:** [FeedbackTagResource](#model/FeedbackTagResource)[]
 */
export const getApiV1FeedbackTags = <ThrowOnError extends boolean = false>(options: Options<GetApiV1FeedbackTagsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1FeedbackTagsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback-tags',
    ...options
});

/**
 * **Response:** [FeedbackTagResource](#model/FeedbackTagResource)
 */
export const postApiV1FeedbackTags = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1FeedbackTagsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1FeedbackTagsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1FeedbackTagsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1FeedbackTagsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1FeedbackTagsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback-tags/{id}',
    ...options
});

/**
 * **Response:** [FeedbackTagResource](#model/FeedbackTagResource)
 */
export const getApiV1FeedbackTagsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1FeedbackTagsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1FeedbackTagsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback-tags/{id}',
    ...options
});

/**
 * **Response:** [FeedbackTagResource](#model/FeedbackTagResource)
 */
export const putApiV1FeedbackTagsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1FeedbackTagsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1FeedbackTagsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback-tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1HealthCheck = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1HealthCheckData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1HealthCheckResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/health-check',
    ...options
});

/**
 * **Response:** [IdeaBoardEntryResource](#model/IdeaBoardEntryResource)[]
 */
export const postApiV1IdeaBoardEntriesBulkApprove = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesBulkApproveData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/bulk-approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [IdeaBoardEntryResource](#model/IdeaBoardEntryResource)[]
 */
export const postApiV1IdeaBoardEntriesBulkTag = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesBulkTagData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/bulk-tag',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1IdeaBoardEntriesBulkDestroy = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1IdeaBoardEntriesBulkDestroyData, ThrowOnError>) => (options.client ?? client).delete<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/bulk-destroy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/idea-board-entries
 *
 * List idea board entries.
 *
 * **Response:** [IdeaBoardEntryResource](#model/IdeaBoardEntryResource)[]
 */
export const getApiV1IdeaBoardEntries = <ThrowOnError extends boolean = false>(options: Options<GetApiV1IdeaBoardEntriesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1IdeaBoardEntriesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries',
    ...options
});

/**
 * /api/v1/idea-board-entries
 *
 * Create an idea board entry.
 *
 * **Response:** [IdeaBoardEntryResource](#model/IdeaBoardEntryResource)
 */
export const postApiV1IdeaBoardEntries = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1IdeaBoardEntriesData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1IdeaBoardEntriesResponses, PostApiV1IdeaBoardEntriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/idea-board-entries/{id}
 *
 * Delete an idea board entry.
 */
export const deleteApiV1IdeaBoardEntriesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1IdeaBoardEntriesIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1IdeaBoardEntriesIdResponses, DeleteApiV1IdeaBoardEntriesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{id}',
    ...options
});

/**
 * /api/v1/idea-board-entries/{id}
 *
 * Show an idea board entry.
 *
 * **Response:** [IdeaBoardEntryResource](#model/IdeaBoardEntryResource)
 */
export const getApiV1IdeaBoardEntriesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1IdeaBoardEntriesIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1IdeaBoardEntriesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{id}',
    ...options
});

/**
 * /api/v1/idea-board-entries/{id}
 *
 * Update an idea board entry.
 *
 * **Response:** [IdeaBoardEntryResource](#model/IdeaBoardEntryResource)
 */
export const putApiV1IdeaBoardEntriesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1IdeaBoardEntriesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1IdeaBoardEntriesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1IdeaBoardEntriesExcelExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1IdeaBoardEntriesExcelExportUrlData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/excel-export-url',
    ...options
});

/**
 * **Response:** [IdeaBoardEntryResource](#model/IdeaBoardEntryResource)
 */
export const postApiV1IdeaBoardEntriesIdeaBoardEntryIdVote = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteData, ThrowOnError>) => (options.client ?? client).post<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteResponses, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{idea_board_entry_id}/vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [CommentResource](#model/CommentResource)
 */
export const postApiV1IdeaBoardEntriesIdeaBoardEntryIdComment = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentData, ThrowOnError>) => (options.client ?? client).post<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentResponses, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{idea_board_entry_id}/comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [IdeaBoardEntryResource](#model/IdeaBoardEntryResource)
 */
export const postApiV1IdeaBoardEntriesIdeaBoardEntryIdApprove = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdApproveData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{idea_board_entry_id}/approve',
    ...options
});

/**
 * **Response:** [IdeaBoardEntryResource](#model/IdeaBoardEntryResource)
 */
export const postApiV1IdeaBoardEntriesIdeaBoardEntryIdUnapprove = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdUnapproveData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{idea_board_entry_id}/unapprove',
    ...options
});

export const deleteApiV1CommentsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1CommentsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1CommentsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{id}',
    ...options
});

/**
 * **Response:** [CommentResource](#model/CommentResource)
 */
export const getApiV1CommentsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CommentsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1CommentsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{id}',
    ...options
});

/**
 * **Response:** [CommentResource](#model/CommentResource)
 */
export const putApiV1CommentsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1CommentsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1CommentsIdResponses, PutApiV1CommentsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [CommentResource](#model/CommentResource)
 */
export const postApiV1CommentsCommentIdVote = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommentsCommentIdVoteData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CommentsCommentIdVoteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{comment_id}/vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [CommentResource](#model/CommentResource)
 */
export const postApiV1CommentsParentCommentIdComment = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommentsParentCommentIdCommentData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CommentsParentCommentIdCommentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{parent_comment_id}/comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [CommentResource](#model/CommentResource)
 */
export const postApiV1CommentsCommentIdApprove = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommentsCommentIdApproveData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{comment_id}/approve',
    ...options
});

/**
 * **Response:** [CommentResource](#model/CommentResource)
 */
export const postApiV1CommentsCommentIdUnapprove = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommentsCommentIdUnapproveData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{comment_id}/unapprove',
    ...options
});

export const getApiV1IdeaBoardEntriesExcel = <ThrowOnError extends boolean = false>(options: Options<GetApiV1IdeaBoardEntriesExcelData, ThrowOnError>) => (options.client ?? client).get<GetApiV1IdeaBoardEntriesExcelResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/excel',
    ...options
});

/**
 * **Response:** [CommentResource](#model/CommentResource)[]
 */
export const getApiV1Comments = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CommentsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1CommentsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments',
    ...options
});

/**
 * **Response:** [EventLogResource](#model/EventLogResource)[]
 */
export const getApiV1EventLogs = <ThrowOnError extends boolean = false>(options: Options<GetApiV1EventLogsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1EventLogsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/event-logs',
    ...options
});

export const postApiV1MessagingSendMessage = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1MessagingSendMessageData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1MessagingSendMessageResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/messaging/send-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiV1MessagingSendTestMessage = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1MessagingSendTestMessageData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1MessagingSendTestMessageResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/messaging/send-test-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [ParticipantGroupSurveyStageResource](#model/ParticipantGroupSurveyStageResource)[]
 */
export const getApiV1Submissions = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SubmissionsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SubmissionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/submissions',
    ...options
});

/**
 * **Response:** [ParticipantGroupSurveyStageResource](#model/ParticipantGroupSurveyStageResource)
 */
export const putApiV1SubmissionsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SubmissionsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SubmissionsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/submissions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [ParticipantGroupSurveyStageResource](#model/ParticipantGroupSurveyStageResource)[]
 */
export const getApiV1SubmissionsPublic = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SubmissionsPublicData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SubmissionsPublicResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/submissions/public',
    ...options
});

export const putApiV1ParticipantGroupsSyncTags = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1ParticipantGroupsSyncTagsData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1ParticipantGroupsSyncTagsResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/sync-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiV1ParticipantGroupsParticipantGroupIdSyncToStage = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupsParticipantGroupIdSyncToStageData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupsParticipantGroupIdSyncToStageResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/sync-to-stage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changing a participant group's stage state via update-state must write a log entry
 * (LogEvent) capturing the old and new state.
 */
export const putChangingAParticipantGroupSStageStateViaUpdateStateMustWriteALogEntryLogEventCapturingTheOldAndNewState = <ThrowOnError extends boolean = false>(options?: Options<PutChangingAParticipantGroupSStageStateViaUpdateStateMustWriteALogEntryLogEventCapturingTheOldAndNewStateData, ThrowOnError>) => (options?.client ?? client).put<PutChangingAParticipantGroupSStageStateViaUpdateStateMustWriteALogEntryLogEventCapturingTheOldAndNewStateResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/update-state',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [ParticipantGroupResource](#model/ParticipantGroupResource)[]
 */
export const getApiV1ParticipantGroups = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups',
    ...options
});

/**
 * **Response:** [ParticipantGroupResource](#model/ParticipantGroupResource)
 */
export const postApiV1ParticipantGroups = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1ParticipantGroupsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1ParticipantGroupsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1ParticipantGroupsParticipantGroupId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1ParticipantGroupsParticipantGroupIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ParticipantGroupsParticipantGroupIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participant_group_id}',
    ...options
});

/**
 * /api/v1/participant-groups/{participant_group_id}
 *
 * Show a participant group.
 */
export const getApiV1ParticipantGroupsParticipantGroupId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupsParticipantGroupIdData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participant_group_id}',
    ...options
});

/**
 * **Response:** [ParticipantGroupResource](#model/ParticipantGroupResource)
 */
export const putApiV1ParticipantGroupsParticipantGroupId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupsParticipantGroupIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupsParticipantGroupIdResponses, PutApiV1ParticipantGroupsParticipantGroupIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participant_group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1ParticipantGroupsDelete = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1ParticipantGroupsDeleteData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1ParticipantGroupsDeleteResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1SpacesSpaceIdUsersUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpacesSpaceIdUsersUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpacesSpaceIdUsersUserIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_id}/users/{user_id}',
    ...options
});

export const getApiV1ParticipantGroupsExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupsExportUrlData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/export-url',
    ...options
});

/**
 * **Response:** [TeamMemberResource](#model/TeamMemberResource)[]
 */
export const getApiV1ParticipantGroupsParticipantGroupIdUsers = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupsParticipantGroupIdUsersData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupsParticipantGroupIdUsersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/users',
    ...options
});

/**
 * EMI-5799 (related path). A SpaceUser for the given email/space exists but
 * was previously soft-deleted. The endpoint must restore the existing
 * SpaceUser and attach it to the group, not create a duplicate row.
 */
export const postEmi5799RelatedPathASpaceUserForTheGivenEmailSpaceExistsButWasPreviouslySoftDeletedTheEndpointMustRestoreTheExistingSpaceUserAndAttachItToTheGroupNotCreateADuplicateRow = <ThrowOnError extends boolean = false>(options: Options<PostEmi5799RelatedPathASpaceUserForTheGivenEmailSpaceExistsButWasPreviouslySoftDeletedTheEndpointMustRestoreTheExistingSpaceUserAndAttachItToTheGroupNotCreateADuplicateRowData, ThrowOnError>) => (options.client ?? client).post<PostEmi5799RelatedPathASpaceUserForTheGivenEmailSpaceExistsButWasPreviouslySoftDeletedTheEndpointMustRestoreTheExistingSpaceUserAndAttachItToTheGroupNotCreateADuplicateRowResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/users/{spaceUser_id}',
    ...options
});

export const getApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdf = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdfData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdfResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/feedback-for-survey/{survey_id}/pdf',
    ...options
});

export const putApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdf = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdfData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdfResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/associate-offline-submission-pdf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdf = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdfData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdfResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/disassociate-offline-submission-pdf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change team admin of a participant group.
 *
 * Requirements:
 * - Space Admin & Survey Admins (only for surveys they admin and attached to the group) can change team admin.
 * - Participants can only change if they are already the team admin of the group.
 * - New admin must already be a member of the group.
 * - When called: update group_admin_user_id, copy contact fields, sync pivot, and log the transfer.
 *
 * **Response:** [ParticipantGroupResource](#model/ParticipantGroupResource)
 */
export const postChangeTeamAdminOfAParticipantGroup = <ThrowOnError extends boolean = false>(options: Options<PostChangeTeamAdminOfAParticipantGroupData, ThrowOnError>) => (options.client ?? client).post<PostChangeTeamAdminOfAParticipantGroupResponses, PostChangeTeamAdminOfAParticipantGroupErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/change-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1Participants = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1ParticipantsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1ParticipantsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiV1ParticipantsCsv = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsCsvData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantsCsvResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/csv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1ParticipantsImportTemplate = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ParticipantsImportTemplateData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ParticipantsImportTemplateResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/import-template',
    ...options
});

export const postApiV1ParticipantsImportFromTemplate = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsImportFromTemplateData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/import-from-template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1ParticipantsCheckCsv = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsCheckCsvData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantsCheckCsvResponses, PostApiV1ParticipantsCheckCsvErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/check-csv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1ParticipantsGetCountOnStage = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ParticipantsGetCountOnStageData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ParticipantsGetCountOnStageResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/get-count-on-stage',
    ...options
});

export const putApiV1ParticipantsImportFromStage = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1ParticipantsImportFromStageData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1ParticipantsImportFromStageResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/import-from-stage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [ParticipantGroupResource](#model/ParticipantGroupResource)
 */
export const postApiV1ParticipantsGetOrCreateParticipantGroupForAdmin = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1ParticipantsGetOrCreateParticipantGroupForAdminData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1ParticipantsGetOrCreateParticipantGroupForAdminResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/get-or-create-participant-group-for-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [ParticipantGroupTagResource](#model/ParticipantGroupTagResource)[]
 */
export const getApiV1ParticipantGroupTags = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupTagsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupTagsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-group-tags',
    ...options
});

/**
 * **Response:** [ParticipantGroupTagResource](#model/ParticipantGroupTagResource)
 */
export const postApiV1ParticipantGroupTags = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1ParticipantGroupTagsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1ParticipantGroupTagsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-group-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1ParticipantGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1ParticipantGroupTagsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ParticipantGroupTagsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-group-tags/{id}',
    ...options
});

/**
 * **Response:** [ParticipantGroupTagResource](#model/ParticipantGroupTagResource)
 */
export const getApiV1ParticipantGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupTagsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupTagsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-group-tags/{id}',
    ...options
});

/**
 * **Response:** [ParticipantGroupTagResource](#model/ParticipantGroupTagResource)
 */
export const putApiV1ParticipantGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupTagsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupTagsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-group-tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/participant-import-files
 *
 * List participant import files.
 *
 * **Response:** [ParticipantImportFileResource](#model/ParticipantImportFileResource)[]
 */
export const getApiV1ParticipantImportFiles = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantImportFilesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantImportFilesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-import-files',
    ...options
});

/**
 * /api/v1/participant-import-files
 *
 * Upload a participant import file.
 *
 * **Response:** [ParticipantImportFileResource](#model/ParticipantImportFileResource)
 */
export const postApiV1ParticipantImportFiles = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantImportFilesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantImportFilesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-import-files',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/participant-import-files/{id}
 *
 * Delete a participant import file.
 */
export const deleteApiV1ParticipantImportFilesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1ParticipantImportFilesIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ParticipantImportFilesIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-import-files/{id}',
    ...options
});

/**
 * /api/v1/participant-import-files/{id}
 *
 * Show a participant import file.
 *
 * **Response:** [ParticipantImportFileResource](#model/ParticipantImportFileResource)
 */
export const getApiV1ParticipantImportFilesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantImportFilesIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantImportFilesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-import-files/{id}',
    ...options
});

/**
 * /api/v1/participant-import-files/{id}
 *
 * Update a participant import file.
 *
 * **Response:** [ParticipantImportFileResource](#model/ParticipantImportFileResource)
 */
export const putApiV1ParticipantImportFilesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantImportFilesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantImportFilesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-import-files/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1ParticipantGroupsExport = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupsExportData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupsExportResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/export',
    ...options
});

/**
 * **Response:** [PlatformFeedbackResource](#model/PlatformFeedbackResource)[]
 */
export const getApiV1PlatformFeedbacks = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PlatformFeedbacksData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PlatformFeedbacksResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/platform-feedbacks',
    ...options
});

/**
 * **Response:** [PlatformFeedbackResource](#model/PlatformFeedbackResource)
 */
export const postApiV1PlatformFeedbacks = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1PlatformFeedbacksData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1PlatformFeedbacksResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/platform-feedbacks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [PlatformFeedbackResource](#model/PlatformFeedbackResource)
 */
export const getApiV1PlatformFeedbacksId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PlatformFeedbacksIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PlatformFeedbacksIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/platform-feedbacks/{id}',
    ...options
});

/**
 * **Response:** [PlatformFeedbackResource](#model/PlatformFeedbackResource)
 */
export const putApiV1PlatformFeedbacksId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1PlatformFeedbacksIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1PlatformFeedbacksIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/platform-feedbacks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SpacesSpaceIdAdmins = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SpacesSpaceIdAdminsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SpacesSpaceIdAdminsResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_id}/admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SpacesSpaceIdAdminsSpaceUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpacesSpaceIdAdminsSpaceUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpacesSpaceIdAdminsSpaceUserIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_id}/admins/{spaceUser_id}',
    ...options
});

/**
 * /api/v1/spaces
 *
 * Spaces list.
 *
 * **Response:** [SpaceResource](#model/SpaceResource)[]
 */
export const getApiV1Spaces = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpacesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SpacesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/spaces',
    ...options
});

/**
 * **Response:** [SpaceResource](#model/SpaceResource)
 */
export const postApiV1Spaces = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SpacesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SpacesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [SpaceResource](#model/SpaceResource)
 */
export const getApiV1SpacesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpacesIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SpacesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{id}',
    ...options
});

/**
 * **Response:** [SpaceResource](#model/SpaceResource)
 */
export const putApiV1SpacesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SpacesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SpacesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SpacesSpaceIdTermsOfUsePdf = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpacesSpaceIdTermsOfUsePdfData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpacesSpaceIdTermsOfUsePdfResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_id}/terms-of-use-pdf',
    ...options
});

export const deleteApiV1SpacesSpaceIdFavicon = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpacesSpaceIdFaviconData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpacesSpaceIdFaviconResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_id}/favicon',
    ...options
});

export const getApiV1SpacesSpaceIdLogo = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpacesSpaceIdLogoData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_id}/logo',
    ...options
});

/**
 * **Response:** [SpaceAssetResource](#model/SpaceAssetResource)[]
 */
export const getApiV1SpaceAssets = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpaceAssetsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SpaceAssetsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-assets',
    ...options
});

/**
 * **Response:** [SpaceAssetResource](#model/SpaceAssetResource)
 */
export const postApiV1SpaceAssets = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SpaceAssetsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SpaceAssetsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SpaceAssetsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpaceAssetsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpaceAssetsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-assets/{id}',
    ...options
});

/**
 * **Response:** [SpaceAssetResource](#model/SpaceAssetResource)
 */
export const getApiV1SpaceAssetsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpaceAssetsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SpaceAssetsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-assets/{id}',
    ...options
});

/**
 * **Response:** [SpaceAssetResource](#model/SpaceAssetResource)
 */
export const putApiV1SpaceAssetsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SpaceAssetsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SpaceAssetsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-assets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SpaceAssetsSpaceAssetIdDownloadFilename = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpaceAssetsSpaceAssetIdDownloadFilenameData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SpaceAssetsSpaceAssetIdDownloadFilenameResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-assets/{spaceAsset_id}/download/{filename}',
    ...options
});

export const deleteApiV1SpaceUsersSpaceUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpaceUsersSpaceUserIdData, ThrowOnError>) => (options.client ?? client).delete<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-users/{spaceUser_id}',
    ...options
});

/**
 * EMI-5799 (related path). A user changes their own email to one that
 * belongs to a previously soft-deleted User account. The current behaviour
 * crashes with UniqueConstraintViolationException because the conflict
 * lookup in ConflictedUsersResolveService does not consider trashed rows;
 * the email update at the end of the flow then collides with the unique
 * index on users.email.
 *
 * **Response:** [SpaceUserResource](#model/SpaceUserResource)
 */
export const putEmi5799RelatedPathAuserChangesTheirOwnEmailToOneThatBelongsToAPreviouslySoftDeletedUserAccountTheCurrentBehaviourCrashesWithUniqueConstraintViolationExceptionBecauseTheConflictLookupInConflictedUsersResolveServiceDoesNotConsiderTrashedRowsTheEmailUpdateAtTheEndOfTheFlowThenCollidesWithTheUniqueIndexOnUsersEmail = <ThrowOnError extends boolean = false>(options: Options<PutEmi5799RelatedPathAuserChangesTheirOwnEmailToOneThatBelongsToAPreviouslySoftDeletedUserAccountTheCurrentBehaviourCrashesWithUniqueConstraintViolationExceptionBecauseTheConflictLookupInConflictedUsersResolveServiceDoesNotConsiderTrashedRowsTheEmailUpdateAtTheEndOfTheFlowThenCollidesWithTheUniqueIndexOnUsersEmailData, ThrowOnError>) => (options.client ?? client).put<PutEmi5799RelatedPathAuserChangesTheirOwnEmailToOneThatBelongsToAPreviouslySoftDeletedUserAccountTheCurrentBehaviourCrashesWithUniqueConstraintViolationExceptionBecauseTheConflictLookupInConflictedUsersResolveServiceDoesNotConsiderTrashedRowsTheEmailUpdateAtTheEndOfTheFlowThenCollidesWithTheUniqueIndexOnUsersEmailResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-users/{spaceUser_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SpaceUsersUnionConflictedSpaceUsersAndLogin = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SpaceUsersUnionConflictedSpaceUsersAndLoginData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SpaceUsersUnionConflictedSpaceUsersAndLoginResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-users/union-conflicted-space-users-and-login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiV1SpaceUsersSpaceUserIdUnlock = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SpaceUsersSpaceUserIdUnlockData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SpaceUsersSpaceUserIdUnlockResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-users/{spaceUser_id}/unlock',
    ...options
});

/**
 * **Response:** [SpaceUserResource](#model/SpaceUserResource)[]
 */
export const getApiV1SpaceUsers = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpaceUsersData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SpaceUsersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-users',
    ...options
});

/**
 * **Response:** [EvaluationPageSettingResource](#model/EvaluationPageSettingResource)
 */
export const getApiV1EvaluationPageSettings = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1EvaluationPageSettingsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1EvaluationPageSettingsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-page-settings',
    ...options
});

/**
 * **Response:** [EvaluationPageSettingResource](#model/EvaluationPageSettingResource)
 */
export const postApiV1EvaluationPageSettings = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1EvaluationPageSettingsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1EvaluationPageSettingsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-page-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1EvaluationPageSettingsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1EvaluationPageSettingsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1EvaluationPageSettingsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-page-settings/{id}',
    ...options
});

/**
 * **Response:** [EvaluationPageSettingResource](#model/EvaluationPageSettingResource)
 */
export const putApiV1EvaluationPageSettingsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1EvaluationPageSettingsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1EvaluationPageSettingsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-page-settings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1StorageFilesPath = <ThrowOnError extends boolean = false>(options: Options<GetApiV1StorageFilesPathData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/storage/files/{path}',
    ...options
});

export const getApiV1SupportZohoOauth = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SupportZohoOauthData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/support/zoho-oauth',
    ...options
});

export const postApiV1SupportRequests = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SupportRequestsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SupportRequestsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/support/requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveysSurveyIdRemoveParticipantGroups = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveysSurveyIdRemoveParticipantGroupsData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveysSurveyIdRemoveParticipantGroupsResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/remove-participant-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [SpaceUserResource](#model/SpaceUserResource)[]
 */
export const getApiV1SurveysSurveyIdUsers = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyIdUsersData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysSurveyIdUsersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/users',
    ...options
});

/**
 * Reproduces EMI-5799. A User with the invited email exists but was previously
 * soft-deleted, and no SpaceUser exists for that email in the survey's space.
 *
 * The endpoint must restore the soft-deleted User and attach a fresh SpaceUser
 * instead of attempting to insert a duplicate row.
 *
 * **Response:** [SpaceUserResource](#model/SpaceUserResource)
 */
export const postReproducesEmi5799aUserWithTheInvitedEmailExistsButWasPreviouslySoftDeletedAndNoSpaceUserExistsForThatEmailInTheSurveySSpace = <ThrowOnError extends boolean = false>(options: Options<PostReproducesEmi5799aUserWithTheInvitedEmailExistsButWasPreviouslySoftDeletedAndNoSpaceUserExistsForThatEmailInTheSurveySSpaceData, ThrowOnError>) => (options.client ?? client).post<PostReproducesEmi5799aUserWithTheInvitedEmailExistsButWasPreviouslySoftDeletedAndNoSpaceUserExistsForThatEmailInTheSurveySSpaceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveysSurveyIdUsersSpaceUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveysSurveyIdUsersSpaceUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveysSurveyIdUsersSpaceUserIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/users/{spaceUser_id}',
    ...options
});

export const getApiV1SurveysSurveyIdTags = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyIdTagsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysSurveyIdTagsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/tags',
    ...options
});

export const postApiV1SurveysSurveyIdSendInvitationEmail = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdSendInvitationEmailData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdSendInvitationEmailResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/send-invitation-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdSendRecordingReminder = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdSendRecordingReminderData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdSendRecordingReminderResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/send-recording-reminder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdSendSubmittingReminder = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdSendSubmittingReminderData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdSendSubmittingReminderResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/send-submitting-reminder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdSendParticipantReactionReport = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdSendParticipantReactionReportData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/send-participant-reaction-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveysSurveyIdKeyFigures = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyIdKeyFiguresData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysSurveyIdKeyFiguresResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/key-figures',
    ...options
});

export const getApiV1SurveysSurveyIdStats = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyIdStatsData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/stats',
    ...options
});

/**
 * **Response:** [ParticipantGroupResource](#model/ParticipantGroupResource)
 */
export const postApiV1SurveysSurveyIdSubmit = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdSubmitData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdSubmitResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [ParticipantGroupResource](#model/ParticipantGroupResource)
 */
export const postApiV1SurveysSurveyIdRevokeSubmit = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdRevokeSubmitData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdRevokeSubmitResponses, PostApiV1SurveysSurveyIdRevokeSubmitErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/revoke-submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdPublishSubmission = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdPublishSubmissionData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdPublishSubmissionResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/publish-submission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdDispatchSearchForSimilarEvaluationGroups = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdDispatchSearchForSimilarEvaluationGroupsData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/dispatch-search-for-similar-evaluation-groups',
    ...options
});

export const putApiV1SurveysSort = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveysSortData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveysSortResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const putApiV1SurveysSurveyIdArchive = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveysSurveyIdArchiveData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveysSurveyIdArchiveResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/archive',
    ...options
});

export const putApiV1SurveysSurveyIdUnarchive = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveysSurveyIdUnarchiveData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveysSurveyIdUnarchiveResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/unarchive',
    ...options
});

export const getApiV1SurveysGeneralReportDownload = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysGeneralReportDownloadData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/general-report-download',
    ...options
});

/**
 * **Response:** [SurveyResource](#model/SurveyResource)[]
 */
export const getApiV1Surveys = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys',
    ...options
});

/**
 * **Response:** [SurveyResource](#model/SurveyResource)
 */
export const postApiV1Surveys = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveysData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveysResponses, PostApiV1SurveysErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1SurveysId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveysIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveysIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{id}',
    ...options
});

/**
 * Update a survey.
 *
 * **Response:** [SurveyResource](#model/SurveyResource)
 */
export const putUpdateASurvey = <ThrowOnError extends boolean = false>(options: Options<PutUpdateASurveyData, ThrowOnError>) => (options.client ?? client).put<PutUpdateASurveyResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [SurveyResource](#model/SurveyResource)
 */
export const postApiV1SurveysSurveyIdCopy = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdCopyData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdCopyResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyCategoriesSort = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyCategoriesSortData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyCategoriesSortResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-categories/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * **Response:** [SurveyCategoryResource](#model/SurveyCategoryResource)[]
 */
export const getApiV1SurveyCategories = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyCategoriesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyCategoriesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-categories',
    ...options
});

/**
 * **Response:** [SurveyCategoryResource](#model/SurveyCategoryResource)
 */
export const postApiV1SurveyCategories = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyCategoriesData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyCategoriesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1SurveyCategoriesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyCategoriesIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyCategoriesIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-categories/{id}',
    ...options
});

/**
 * **Response:** [SurveyCategoryResource](#model/SurveyCategoryResource)
 */
export const getApiV1SurveyCategoriesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyCategoriesIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyCategoriesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-categories/{id}',
    ...options
});

/**
 * **Response:** [SurveyCategoryResource](#model/SurveyCategoryResource)
 */
export const putApiV1SurveyCategoriesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyCategoriesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyCategoriesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-categories/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * **Response:** [SurveyExportResource](#model/SurveyExportResource)[]
 */
export const getApiV1SurveyExports = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyExportsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyExportsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-exports',
    ...options
});

/**
 * **Response:** [SurveyExportResource](#model/SurveyExportResource)
 */
export const postApiV1SurveyExports = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyExportsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyExportsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-exports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1SurveyExportsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyExportsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyExportsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-exports/{id}',
    ...options
});

/**
 * **Response:** [SurveyExportResource](#model/SurveyExportResource)
 */
export const getApiV1SurveyExportsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyExportsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyExportsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-exports/{id}',
    ...options
});

export const getApiV1SurveyExportsSurveyExportIdDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyExportsSurveyExportIdDownloadUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyExportsSurveyExportIdDownloadUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-exports/{surveyExport_id}/download-url',
    ...options
});

/**
 * **Response:** [SurveyResource](#model/SurveyResource)
 */
export const getApiV1SurveysSurveyBySlug = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyBySlugData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysSurveyBySlugResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{surveyBySlug}',
    ...options
});

export const getApiV1SurveysSurveyBySlugLogo = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyBySlugLogoData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysSurveyBySlugLogoResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{surveyBySlug}/logo',
    ...options
});

/**
 * **Response:** [SurveyTagResource](#model/SurveyTagResource)[]
 */
export const getApiV1SurveyTags = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyTagsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyTagsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-tags',
    ...options
});

/**
 * /api/v1/survey-document-group-tags
 *
 * List document group tags.
 *
 * **Response:** [SurveyDocumentGroupTagResource](#model/SurveyDocumentGroupTagResource)[]
 */
export const getApiV1SurveyDocumentGroupTags = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentGroupTagsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentGroupTagsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-group-tags',
    ...options
});

/**
 * /api/v1/survey-document-group-tags
 *
 * Create a document group tag.
 *
 * **Response:** [SurveyDocumentGroupTagResource](#model/SurveyDocumentGroupTagResource)
 */
export const postApiV1SurveyDocumentGroupTags = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentGroupTagsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentGroupTagsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-group-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-document-group-tags/{id}
 *
 * Delete a document group tag.
 */
export const deleteApiV1SurveyDocumentGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentGroupTagsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentGroupTagsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-group-tags/{id}',
    ...options
});

/**
 * /api/v1/survey-document-group-tags/{id}
 *
 * Show a document group tag.
 *
 * **Response:** [SurveyDocumentGroupTagResource](#model/SurveyDocumentGroupTagResource)
 */
export const getApiV1SurveyDocumentGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentGroupTagsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentGroupTagsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-group-tags/{id}',
    ...options
});

/**
 * /api/v1/survey-document-group-tags/{id}
 *
 * Update a document group tag.
 *
 * **Response:** [SurveyDocumentGroupTagResource](#model/SurveyDocumentGroupTagResource)
 */
export const putApiV1SurveyDocumentGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentGroupTagsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentGroupTagsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-group-tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentGroupsSort = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyDocumentGroupsSortData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyDocumentGroupsSortResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-groups/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-document-groups
 *
 * List document groups.
 *
 * **Response:** [SurveyDocumentGroupResource](#model/SurveyDocumentGroupResource)[]
 */
export const getApiV1SurveyDocumentGroups = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentGroupsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentGroupsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-groups',
    ...options
});

/**
 * /api/v1/survey-document-groups
 *
 * Create a document group.
 *
 * **Response:** [SurveyDocumentGroupResource](#model/SurveyDocumentGroupResource)
 */
export const postApiV1SurveyDocumentGroups = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentGroupsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentGroupsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1SurveyDocumentGroupsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentGroupsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentGroupsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-groups/{id}',
    ...options
});

/**
 * /api/v1/survey-document-groups/{id}
 *
 * Show a document group.
 *
 * **Response:** [SurveyDocumentGroupResource](#model/SurveyDocumentGroupResource)
 */
export const getApiV1SurveyDocumentGroupsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentGroupsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentGroupsIdResponses, GetApiV1SurveyDocumentGroupsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-groups/{id}',
    ...options
});

/**
 * /api/v1/survey-document-groups/{id}
 *
 * Update a document group.
 *
 * **Response:** [SurveyDocumentGroupResource](#model/SurveyDocumentGroupResource)
 */
export const putApiV1SurveyDocumentGroupsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentGroupsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentGroupsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentsSort = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1SurveyDocumentsSortData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1SurveyDocumentsSortResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelExportUrlData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/{survey_document_id}/question-answers-excel-export-url',
    ...options
});

/**
 * /api/v1/survey-documents
 *
 * List survey documents.
 *
 * **Response:** [SurveyDocumentResource](#model/SurveyDocumentResource)[]
 */
export const getApiV1SurveyDocuments = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents',
    ...options
});

/**
 * /api/v1/survey-documents
 *
 * Create a new survey document.
 *
 * **Response:** [SurveyDocumentResource](#model/SurveyDocumentResource)
 */
export const postApiV1SurveyDocuments = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-documents/{id}
 *
 * Delete a survey document.
 */
export const deleteApiV1SurveyDocumentsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/{id}',
    ...options
});

/**
 * /api/v1/survey-documents/{id}
 *
 * Show a survey document.
 *
 * **Response:** [SurveyDocumentResource](#model/SurveyDocumentResource)
 */
export const getApiV1SurveyDocumentsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentsIdResponses, GetApiV1SurveyDocumentsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/{id}',
    ...options
});

/**
 * /api/v1/survey-documents/{id}
 *
 * Update a survey document.
 *
 * **Response:** [SurveyDocumentResource](#model/SurveyDocumentResource)
 */
export const putApiV1SurveyDocumentsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentsIdResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/{id}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * **Response:** [SurveyDocumentPageAreaResource](#model/SurveyDocumentPageAreaResource)[]
 */
export const postApiV1SurveyDocumentPageAreasStoreMass = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentPageAreasStoreMassData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentPageAreasStoreMassResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas/store-mass',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-document-page-areas/copy-language
 *
 * Copy all page areas of a survey document from the current language into another language (only when the target language has none).
 *
 * **Response:** [SurveyDocumentPageAreaResource](#model/SurveyDocumentPageAreaResource)[]
 */
export const postApiV1SurveyDocumentPageAreasCopyLanguage = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentPageAreasCopyLanguageData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentPageAreasCopyLanguageResponses, PostApiV1SurveyDocumentPageAreasCopyLanguageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas/copy-language',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-document-page-areas/by-language
 *
 * Delete all page areas of a survey document in the current language.
 */
export const deleteApiV1SurveyDocumentPageAreasByLanguage = <ThrowOnError extends boolean = false>(options?: Options<DeleteApiV1SurveyDocumentPageAreasByLanguageData, ThrowOnError>) => (options?.client ?? client).delete<DeleteApiV1SurveyDocumentPageAreasByLanguageResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas/by-language',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-document-page-areas
 *
 * List document page areas.
 *
 * **Response:** [SurveyDocumentPageAreaResource](#model/SurveyDocumentPageAreaResource)[]
 */
export const getApiV1SurveyDocumentPageAreas = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentPageAreasData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentPageAreasResponses, GetApiV1SurveyDocumentPageAreasErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas',
    ...options
});

/**
 * /api/v1/survey-document-page-areas
 *
 * Create a document page area.
 *
 * **Response:** [SurveyDocumentPageAreaResource](#model/SurveyDocumentPageAreaResource)
 */
export const postApiV1SurveyDocumentPageAreas = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyDocumentPageAreasData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyDocumentPageAreasResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1SurveyDocumentPageAreasId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentPageAreasIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentPageAreasIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas/{id}',
    ...options
});

/**
 * **Response:** [SurveyDocumentPageAreaResource](#model/SurveyDocumentPageAreaResource)
 */
export const putApiV1SurveyDocumentPageAreasId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentPageAreasIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentPageAreasIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcel = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/{surveyDocument_id}/question-answers-excel',
    ...options
});

export const getApiV1SurveyDocumentsSurveyDocumentIdPdf = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentsSurveyDocumentIdPdfData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentsSurveyDocumentIdPdfResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/{surveyDocument_id}/pdf',
    ...options
});

/**
 * **Response:** [SurveyModuleQuestionResource](#model/SurveyModuleQuestionResource)[]
 */
export const getApiV1SurveyModuleQuestions = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyModuleQuestionsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyModuleQuestionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-questions',
    ...options
});

/**
 * **Response:** [SurveyModuleQuestionResource](#model/SurveyModuleQuestionResource)
 */
export const postApiV1SurveyModuleQuestions = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyModuleQuestionsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyModuleQuestionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-questions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1SurveyModuleQuestionsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyModuleQuestionsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyModuleQuestionsIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-questions/{id}',
    ...options
});

/**
 * **Response:** [SurveyModuleQuestionResource](#model/SurveyModuleQuestionResource)
 */
export const putApiV1SurveyModuleQuestionsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyModuleQuestionsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyModuleQuestionsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-questions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswers = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswersData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswersResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-questions/{survey_module_question_id}/delete-answers',
    ...options
});

/**
 * **Response:** [SurveyModuleAnswerResource](#model/SurveyModuleAnswerResource)[]
 */
export const getApiV1SurveyModuleAnswers = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyModuleAnswersData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyModuleAnswersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers',
    ...options
});

/**
 * **Response:** [SurveyModuleAnswerResource](#model/SurveyModuleAnswerResource)
 */
export const postApiV1SurveyModuleAnswers = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyModuleAnswersData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyModuleAnswersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteApiV1SurveyModuleAnswersId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyModuleAnswersIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyModuleAnswersIdResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers/{id}',
    ...options
});

/**
 * **Response:** [SurveyModuleAnswerResource](#model/SurveyModuleAnswerResource)
 */
export const putApiV1SurveyModuleAnswersId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyModuleAnswersIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyModuleAnswersIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyModuleAnswersExcelExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyModuleAnswersExcelExportUrlData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers/excel-export-url',
    ...options
});

export const getApiV1SurveyModuleAnswersExcel = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyModuleAnswersExcelData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyModuleAnswersExcelResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers/excel',
    ...options
});

export const getApiV1SurveyStagesSurveyStageIdParticipantGroupsParticipantGroupIdCheckSubmittingRights = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyStagesSurveyStageIdParticipantGroupsParticipantGroupIdCheckSubmittingRightsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyStagesSurveyStageIdParticipantGroupsParticipantGroupIdCheckSubmittingRightsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{surveyStage_id}/participant-groups/{participantGroup_id}/check-submitting-rights',
    ...options
});

export const postApiV1SurveyStagesSurveyStageIdParticipantGroupsAttach = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyStagesSurveyStageIdParticipantGroupsAttachData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyStagesSurveyStageIdParticipantGroupsAttachResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{surveyStage_id}/participant-groups/attach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveyStagesSurveyStageIdParticipantGroupsDetach = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyStagesSurveyStageIdParticipantGroupsDetachData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyStagesSurveyStageIdParticipantGroupsDetachResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{surveyStage_id}/participant-groups/detach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-stages
 *
 * List survey stages.
 *
 * **Response:** [SurveyStageResource](#model/SurveyStageResource)[]
 */
export const getApiV1SurveyStages = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyStagesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyStagesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages',
    ...options
});

/**
 * /api/v1/survey-stages
 *
 * Create a survey stage.
 *
 * **Response:** [SurveyStageResource](#model/SurveyStageResource)
 */
export const postApiV1SurveyStages = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SurveyStagesData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SurveyStagesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * /api/v1/survey-stages/{id}
 *
 * Delete a survey stage.
 */
export const deleteApiV1SurveyStagesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyStagesIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyStagesIdResponses, DeleteApiV1SurveyStagesIdErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{id}',
    ...options
});

/**
 * /api/v1/survey-stages/{id}
 *
 * Show a survey stage.
 *
 * **Response:** [SurveyStageResource](#model/SurveyStageResource)
 */
export const getApiV1SurveyStagesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyStagesIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyStagesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{id}',
    ...options
});

/**
 * /api/v1/survey-stages/{id}
 *
 * Update a survey stage.
 *
 * **Response:** [SurveyStageResource](#model/SurveyStageResource)
 */
export const putApiV1SurveyStagesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyStagesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyStagesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1TranslationsFlush = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1TranslationsFlushData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/translations/flush',
    ...options
});

export const postApiV1LocalesFlush = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1LocalesFlushData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/locales/flush',
    ...options
});

export const getApiV1LocalesLangTranslationJson = <ThrowOnError extends boolean = false>(options: Options<GetApiV1LocalesLangTranslationJsonData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/locales/{lang}/translation.json',
    ...options
});

/**
 * /api/v1/oauth/user
 *
 * Get authenticated user.
 *
 * **Response:** [UserResource](#model/UserResource)
 */
export const getApiV1OauthUser = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1OauthUserData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1OauthUserResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/oauth/user',
    ...options
});

/**
 * **Response:** [UserResource](#model/UserResource)
 */
export const putApiV1UsersUserId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1UsersUserIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersUserIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1UsersUserIdVerifyEmail = <ThrowOnError extends boolean = false>(options: Options<PutApiV1UsersUserIdVerifyEmailData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersUserIdVerifyEmailResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}/verify-email',
    ...options
});
